import * as actionTypes from "../../actions/actionTypes";

const initialState = {
    profilingRating: null,
    loadingProfilingRating: false,

    profilingQueueApplications: [],
    loadingProfilingQueueApplications: false,

    profilingSpecialities: [],
    loadingProfilingSpecialities: false,

    updatedApplication: null
};

const loadProfilingRating = (state) => {
    return {
        ...state,
        loadingProfilingRating: true
    }
}

const loadProfilingQueueApplications = (state) => {
    return {
        ...state,
        loadingProfilingQueueApplications: true
    }
}

const loadProfilingSpecialities = (state) => {
    return {
        ...state,
        loadingProfilingSpecialities: true
    }
}

const setProfilingRating = (state, action) => {
    return {
        ...state,
        profilingRating: action.profilingRating,
        loadingProfilingRating: false
    }
};

const setProfilingQueueApplications = (state, action) => {
    let tmp = [...action.profilingQueueApplications]
    return {
        ...state,
        profilingQueueApplications: tmp,
        loadingProfilingQueueApplications: false
    }
};

const setProfilingSpecialities = (state, action) => {
    let tmp = [...action.profilingSpecialities]
    return {
        ...state,
        profilingSpecialities: tmp,
        loadingProfilingSpecialities: false
    }
};

const createProfilingApplicationRequest = (state) => {
    return {
        ...state,
        loading: {
            createProfilingApplication: true
        }
    };
};

const createProfilingApplicationSuccess = (state, action) => {
    return {
        ...state,
        profilingQueueApplications: [action.payload, ...state.profilingQueueApplications],
        loading: {}
    };
};

const createProfilingApplicationFailure = (state, action) => {
    return {
        ...state,
        loading: {},
        errors: {
            createProfilingApplication: action.error
        }
    };
};

const updateProfilingApplicationRequestSuccess = (state, action) => {
    return {
        ...state,
        updatedApplication: action.payload, // Сохраняем обновленную заявку
        loading: {}
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_PROFILING_RATING: return loadProfilingRating(state);
        case actionTypes.SET_PROFILING_RATING: return setProfilingRating(state, action);

        case actionTypes.LOAD_PROFILING_QUEUE_APPLICATIONS: return loadProfilingQueueApplications(state);
        case actionTypes.SET_PROFILING_QUEUE_APPLICATIONS: return setProfilingQueueApplications(state, action);

        case actionTypes.LOAD_PROFILING_SPECIALITIES: return loadProfilingSpecialities(state);
        case actionTypes.SET_PROFILING_SPECIALITIES: return setProfilingSpecialities(state, action);

        case actionTypes.CREATE_PROFILING_APPLICATION_REQUEST:
            return createProfilingApplicationRequest(state);
        case actionTypes.CREATE_PROFILING_APPLICATION_SUCCESS:
            return createProfilingApplicationSuccess(state, action);
        case actionTypes.CREATE_PROFILING_APPLICATION_FAILURE:
            return createProfilingApplicationFailure(state, action);
        case actionTypes.UPDATE_PROFILING_APPLICATION_REQUEST_SUCCESS:
            return updateProfilingApplicationRequestSuccess(state, action);
        default: return state;
    }
};
export default reducer;
